import React from "react";

import axios2 from 'services/axios2';

import {useParams} from "react-router-dom";
import {Link,hashHistory} from 'react-router-dom';
import { ToastContainer, toast } from 'react-toastify';
import NuDropdown from "../../components/nubox/NuDropdown";


import { withRouterJim } from "router/withRouterJim";
import Child from "views/cita_all/Child";
import CitaModal from "views/cita_all/CitaModal";
//import listac from '../assets/img/lista2.png';
import NuConfirm from "components/nubox/Box/NuConfirm";

import { NotificationContainer, NotificationManager } from 'react-notifications';
import {
  Table,
  Button,
  Container,
  Modal,
  ModalHeader,
  ModalBody,
  FormGroup,
  ModalFooter,
  ToastHeader,
} from "reactstrap";
import { Save } from "@material-ui/icons";


const cbo=[
  {  value:'1', label: 'label1'},
];
const data = [
  { id_cita: 1, id_citaho:0, hora: "00:00", hora_ini: "00:30", historia:'V-415', paciente:"", motivo:"", atendido_sn:"", id_estadoc:""},
  { id_cita: 2, id_citaho:0, hora: "00:00", hora_ini: "00:30", historia:'V-415', paciente:"", motivo:"", atendido_sn:"", id_estadoc:""},
 
];

//$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$
class CitasHoy extends React.Component {
  
  myRef = React.createRef();//create ref
  citaRef = React.createRef();//create ref

  state = {
    data: data,/* lista de citas */
    form: {
      id_medico: 0,
      fecha: "",
    },
    medicos:[],
  };
  
  //-----------------------------------------------
 
  //------------------------------------------------------
  componentDidMount() {
    console.log("componentDidMount citas");
    //--limpiamos el array de prueba
    this.setState({data:[]});

    const date = new Date();
    const defaultValue = date.toLocaleDateString('en-CA');
  
    //this.setState({fechai: defaultValue}); 
    this.setState({ form:{...this.state.form, fecha: defaultValue,}}); 

    this.cargar_medicos();
    //this.cargar_horas();
    //this.cargar_citas();
    //this.fetchData(this.state.fechai);
    
    
  }

  //----------------especial, actualiza valores del form -------------------------------
  handleChangeForm = (e) => {
    //requerimos la prop name="?" en cada control
    this.setState({
      form: {
        ...this.state.form,
        [e.target.name]: e.target.value,
      },
    });
  }; 
  handleCellChangeCheck=(index, columnId, value)=>{
    
    const newData = [...this.state.data];
    newData[index][columnId] = value;
    
    console.log(newData);
    //setData({  data: newData    });
    this.setState({ datalist: newData });
}
  //======================================================
  //----cargamos los datos desde la base de datos
  /*id_cita, id_medico, fecha,id_citaho, hora_ini, hora_fin, paciente, medico,motivo, 
    cita.obs, atendido_sn, id_estadoc, paciente.cel, paciente.foto_path1 */
  cargar_medicos = () => {
    let param = { 
    }
    
    axios2.post(process.env.REACT_APP_API_URL  + "cbo_medicos", param).then(res => {
        if(res.data.length>0){ 
            //NotificationManager.success("Correcto");
            //---lega un array en este formato:
            //-- { value: 1, label: "Dr. Gerson Abner Villafuerte Oporto" }
            this.setState({medicos: res.data});

            //-- esrtablecemos la primera opcion como la elegida
            this.setState({
              form: {
                ...this.state.form,
                id_medico: res.data[0].value,
              },
            });
            //console.log("cargar_medicos");
            //console.log(this.state.form);

        }else{
            NotificationManager.error("No existen medicos");
        }

    }).catch(error => {
        alert("---- Existio un error ---");
        console.log(error);
        
    });
  };
 
  //----cargamos los datos desde la base de datos
  fetchData = (fechai, id_medico) => {
    let param = { 
      id_espe:1,
      id_medico: id_medico,
      fechai: fechai,
    }
    //console.log(param);

    axios2.post(process.env.REACT_APP_API_URL  + "citahoy_get_citas", param).then(res => {
        if(res.data.length>0){ 
            
            this.setState({ data: res.data});
            
        }else{
            this.setState({ data: []});
            toast.error("No existen registros", {position: toast.POSITION.TOP_LEFT});
        }

    }).catch(error => {
        //if(error.response.status && error.response.status===400)
        alert("Bad Request");
        console.log(error);
        
    });
  };
 
  
  //---clic en el boton para buscar los elementos
  buscar_click=(e)=>{
    //console.log(this.state.fechai);
    if(this.state.fechai==""){
      toast.error("Error Notification !", {
        position: toast.POSITION.TOP_LEFT
      });
      return;
      
    }

    this.fetchData(this.state.form.fecha, this.state.form.id_medico);
    
  }
  
  //-------------------------------------
 
  render() {
    
    return (
      <div>

      <div className="content">
        <ToastContainer />
       
        <section className="content-header">
          <h1>
            <i className="fa fa-calendar"></i> Citas Hoy
          </h1>
        </section>

        <div className="row">
          <div className="col-md-12">
            <div className="box">
              <div className="box-header">

              </div>
              {/* /.box-header */}
              <div className="box-body">
                
                <form   method='POST' className="form-horizontal">

                  <div className="row">
                    <div className="col-md-8">

                      <div className="form-group row">
                        <label className="col-md-3 col-form-label form-control-label">Médico</label>
                        <div className="col-md-9">
                          <NuDropdown
                            options={this.state.medicos}
                            onChange={this.handleChangeForm}
                            value={this.state.form.id_medico}
                            name="id_medico"
                          />
                        </div>
                      </div>

                      <div className="form-group row">
                        <label className="col-md-3 col-form-label form-control-label">Fecha</label>
                        <div className="col-md-9">
                          <input  type="date" 
                                  className="form-control" 
                                  name="fecha" 
                                  value={this.state.form.fecha} 
                                  onChange={ this.handleChangeForm}/>
                        </div>
                      </div>


                      <div className="row">
                        <div className="col-md-12">
                          <button type="button" className="btn btn-md btn-primary"  onClick= { this.buscar_click}>
                            <i className="fa fa-search"></i> Buscar
                          </button>
                        </div>
                      </div>
                    </div>


                    <div className="col-md-4" id="totales">
                      <label style={{ marginTop:"50px", fontSize: "14px" }} className="control-label">Total Ocupados: 
                        <span  id="total-ocupados"></span></label> 
                      <br/>

                      <label style={{ fontSize: "14px" }} className="control-label">Total Disponibles: 
                        <span id="total-disponibles"></span>
                      </label>
                    </div>

                  </div>
                </form>

                <hr />
                  <div className="row">
                    <div className="col-md-12">
                      <div className="alert alert-info titulosBusqueda hidden" role="alert">

                      </div>
                    </div>
                  </div>

                  <div className="row">
                    <div className="col-md-12">
                      <div className="table-responsive">

                        <table id="tabla01" className="table table-striped table-bordered table-condensed table-hover"
                          width="100%" cellSpacing="0" cellPadding="0">
                          <thead>
                            <tr className="btn-primary">
                              <th className="text-center" >Acción</th>
                              <th className="text-center" >Paciente</th>
                              <th className="text-center" >Telefono</th>
                              <th className="text-center" >Hora</th>
                              <th className="text-center" >Motivo</th>
                              <th className="text-center" >Atendido</th>
                              <th className="text-center" >Foto</th>
                              
                            </tr>
                          </thead>
                          <tbody>
                            {/*id_cita, id_medico, id_paciente, fecha,id_citaho, hora_ini, hora_fin, paciente, medico,motivo, 
                                cita.obs, atendido_sn, id_estadoc, 
                                paciente.cel, paciente.foto_path1 */}
                            {this.state.data.map((item, index) => (
                              <tr>
                                <td>
                                  <Link to={ "historia_clinica/"+ item.id_paciente } className="btn btn-warning float-right" 
                                        style={{ background: 'chocolate'}} 
                                        >
                                        <i className="fa fa-fw fa-list-alt"></i> Historia
                                  </Link>
                                </td>
                                <td>{ item.paciente }</td>
                                <td>{ item.cel }</td>
                                <td>{ item.hora_ini }</td>
                                <td>{item.motivo}</td>
                                <td className="text-center" >
                                  
                                </td>
                                <td>
                                  <img src="http://localhost:8080/clinica_dental/public/afiles/1665435807.jpg" className="avatar" alt=""/>
                                </td>
                              </tr>
                            ))}
                          </tbody>
                        </table>

                      </div>
                    </div>
                  </div>
              </div>
              {/* /.box-body */}
            </div>
            {/* /.box -->*/}
          </div>
          {/*<!-- /.col -->*/}
        </div>



      

      </div>
      
      <Child ref={this.myRef} />
      <CitaModal 
        ref={this.citaRef}
        okModal={this.citaOkModal}
        cancelModal={this.citaCancelModal}
        value = {this.state.form.id_cita}
      />
      

      {/*--- modal---- */}
      
      </div>
    );
  }
}
  
  //------------para que soporte la funcionalidad de parametros

export default withRouterJim (CitasHoy);